import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RiskDynamicField } from 'app/risk-register/risk-register.constant';
import { RiskDynamicFieldDeleteMode } from 'app/shared/risk-dynamic-field.service';

@Component({
  selector: 'cygov-delete-dynamic-field-modal',
  templateUrl: './delete-dynamic-field-modal.component.html',
  styleUrls: ['./delete-dynamic-field-modal.component.scss'],
  standalone: false,
})
export class DeleteDynamicFieldModalComponent {
  /** The definition being deleted — only its label is shown. */
  @Input() field: RiskDynamicField = null;

  /** True while the parent's delete is in flight. */
  @Input() isDeleting = false;

  @Output() confirmed = new EventEmitter<RiskDynamicFieldDeleteMode>();
  @Output() cancelled = new EventEmitter<void>();

  readonly deleteModes = RiskDynamicFieldDeleteMode;

  /** Defaults to the destructive option, as the spec shows it preselected. */
  mode: RiskDynamicFieldDeleteMode = RiskDynamicFieldDeleteMode.ALL_RISKS;
  confirmationText = '';

  /**
   * The guard is deliberately exact and case-sensitive: this can delete values
   * across every risk in the entity, and there is no undo.
   */
  get canConfirm(): boolean {
    return !this.isDeleting && this.confirmationText === 'confirm';
  }

  onConfirm(): void {
    if (!this.canConfirm) {
      return;
    }
    this.confirmed.emit(this.mode);
  }

  onCancel(): void {
    this.cancelled.emit();
  }
}
